module.exports = __webpack_public_path__ + "static/media/avatar-11.05afc655.svg";